module.exports = __webpack_public_path__ + "img/exit-preview.c705ae6b.svg";